(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5556],{

/***/ 69859:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/donate/[slug]",
      function () {
        return __webpack_require__(19911);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useFetch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43692);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83244);
/* harmony import */ var isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44743);
/* harmony import */ var _apiHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65639);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54087);
/* harmony import */ var enums_errors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10367);







function fetcher(url, locale) {
    return _fetcher.apply(this, arguments);
}
function _fetcher() {
    _fetcher = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(url, locale) {
        var queryParams, ref, ref1, idToken, headers, _args = arguments;
        return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    queryParams = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {};
                    ;
                    _ctx.next = 4;
                    return (ref = _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === null || _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp */ .H === void 0 ? void 0 : _firebase__WEBPACK_IMPORTED_MODULE_4__/* .firebaseApp.auth */ .H.auth()) === null || ref === void 0 ? void 0 : (ref1 = ref.currentUser) === null || ref1 === void 0 ? void 0 : ref1.getIdToken();
                case 4:
                    idToken = _ctx.sent;
                    headers = {
                        "Content-Type": "application/json",
                        "Accept-Language": locale
                    };
                    if (idToken) {
                        headers["Authorization"] = "Bearer ".concat(idToken);
                    }
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        isomorphic_unfetch__WEBPACK_IMPORTED_MODULE_1___default()("".concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .baseApiUrl */ .td)()).concat(url).concat((0,_apiHelpers__WEBPACK_IMPORTED_MODULE_3__/* .queryStringFromObject */ .jR)(queryParams)), {
                            method: "GET",
                            headers: headers
                        }).then(function(res) {
                            if (res.status === 204) {
                                resolve({});
                            } else if (res.status > 204) {
                                switch(res.status){
                                    case 402:
                                        reject(enums_errors__WEBPACK_IMPORTED_MODULE_5__/* .AppApiError.PaymentNeeded */ .u.PaymentNeeded);
                                        break;
                                    default:
                                        res.json().then(reject);
                                }
                            } else {
                                resolve(res.json());
                            }
                        }).catch(reject);
                    }));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetcher.apply(this, arguments);
}
// hooks use on client side
function useFetch(path, locale) {
    var canLoad = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, queryParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (!path) {
        throw new Error("Path is required");
    }
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(canLoad ? path : null, function() {
        return fetcher(path, locale, queryParams);
    }, {
        revalidateOnMount: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenOffline: false,
        refreshWhenHidden: false,
        refreshInterval: 0
    }), data = ref.data, error = ref.error, isValidating = ref.isValidating, mutate = ref.mutate;
    return {
        data: data,
        error: error,
        isValidating: isValidating,
        mutate: mutate
    };
}


/***/ }),

/***/ 21779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var react_tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85429);
/* harmony import */ var _context_stripeContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16096);





var CardInput = function(param) {
    var className = param.className, _disable = param.disable, disable = _disable === void 0 ? false : _disable;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    var ref = (0,_context_stripeContext__WEBPACK_IMPORTED_MODULE_4__/* .useStripeCtx */ .o)(), stripeCard = ref.stripeCard, stripeError = ref.stripeError, setElementsLoaded = ref.setElementsLoaded, enableCardInput = ref.enableCardInput, disableCardInput = ref.disableCardInput;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setElementsLoaded(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        disable && disableCardInput();
        !disable && enableCardInput();
    }, [
        disable
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "stripe-card-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                className: "info-ico card-info-ico",
                "data-tip": true,
                "data-for": "cardInput",
                onClick: function(e) {
                    return e.stopPropagation();
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: className !== null && className !== void 0 ? className : "",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "info-label",
                        children: t("common:form.payment_card")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_tooltip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        id: "cardInput",
                        place: "top",
                        effect: "solid",
                        className: "dramox-tooltip",
                        isCapture: true,
                        children: t("common:form.card_tooltip")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: stripeCard,
                        className: "stripe-card"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        ref: stripeError
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardInput);


/***/ }),

/***/ 17194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56168);
/* harmony import */ var _api_useFetch__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45509);
/* harmony import */ var _context_authContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13102);
/* harmony import */ var _enums_buyType__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10129);
/* harmony import */ var _CardInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21779);
/* harmony import */ var _LoadingComponent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63104);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53173);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(12701);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);











var Cards = function(param) {
    var setSelected = param.setSelected, selected = param.selected, showCountrySelect = param.showCountrySelect;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    var ref = (0,_context_authContext__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)(), user = ref.user, isUserLoaded = ref.isUserLoaded, isAnonymous = ref.isAnonymous, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), countryOptions = ref1[0], setCountryOptions = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), preselectedCountry = ref2[0], setPreselectedCountry = ref2[1];
    var ref3 = (0,_api_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useFetch */ .i)("/user/cards", locale, !!user), cards = ref3.data, isValidating = ref3.isValidating;
    var ref4 = (0,_api_useFetch__WEBPACK_IMPORTED_MODULE_3__/* .useFetch */ .i)("countries", locale, isUserLoaded && showCountrySelect), countries = ref4.data;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((cards === null || cards === void 0 ? void 0 : cards.length) > 0) {
            var ref;
            var defaulCard = (ref = cards.find(function(card) {
                return card.is_default;
            })) !== null && ref !== void 0 ? ref : cards[0];
            setSelected(defaulCard.id);
        }
    }, [
        cards
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (countries) {
            var ref;
            setCountryOptions(countries === null || countries === void 0 ? void 0 : countries.map(function(c) {
                return {
                    value: c.id,
                    label: c.title
                };
            }));
            setPreselectedCountry((ref = countries.find(function(c) {
                return c.suggested;
            })) === null || ref === void 0 ? void 0 : ref.id);
        }
    }, [
        countries
    ]);
    var loading = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LoadingComponent__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {});
    if (!isUserLoaded || isValidating) {
        return loading;
    }
    if (isAnonymous && isUserLoaded) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: [
                        "email",
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel)
                    ].join(" "),
                    children: [
                        t("common:card_email"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "text",
                            id: "email",
                            name: "email"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                showCountrySelect && !!countryOptions && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: [
                        "email",
                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel)
                    ].join(" "),
                    children: [
                        t("common:country"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            options: countryOptions,
                            defaultLabel: t("common:pick_country"),
                            name: "taxCountry",
                            defaultValue: preselectedCountry
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            ]
        });
    }
    var getLabeledCards = function() {
        return cards.map(function(card) {
            return {
                label: "".concat(card.brand[0].toUpperCase() + card.brand.slice(1), " **** ").concat(card.last_four_digits),
                value: card.id
            };
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: cards && cards.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().cardLabel),
                    children: [
                        t("common:saved_cards"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            defaultLabel: t("common:saved_cards_placeholder"),
                            name: "card",
                            defaultValue: cards[0].id,
                            onChange: setSelected,
                            options: getLabeledCards().concat({
                                label: t("common:add_new_card"),
                                value: _enums_buyType__WEBPACK_IMPORTED_MODULE_5__/* .CardType.NewCard */ .e.NewCard
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                    ]
                }),
                selected === _enums_buyType__WEBPACK_IMPORTED_MODULE_5__/* .CardType.NewCard */ .e.NewCard ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}) : null
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CardInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Cards);


/***/ }),

/***/ 17383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62044);


var StripeDisclaimer = function(param) {
    var className = param.className;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
        className: "stripe-disclaimer ".concat(className !== null && className !== void 0 ? className : ""),
        children: [
            t("common:form.payment_secured_with"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "external",
                href: "https://stripe.com/",
                title: "stripe",
                children: "stripe"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StripeDisclaimer);


/***/ }),

/***/ 19911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(43692);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(2746);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var _api_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66564);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81962);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62044);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46323);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(56047);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56168);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _context_authContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13102);
/* harmony import */ var _components_Cards__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17194);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39933);
/* harmony import */ var _context_stripeContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16096);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28808);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52662);
/* harmony import */ var helpers_Analytics__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86639);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70082);
/* harmony import */ var _components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(3245);
/* harmony import */ var _components_LoadingComponent__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(63104);
/* harmony import */ var components_StripeDisclaimer__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(17383);

























var DonateTheater = function(param) {
    var theatre = param.theatre, donateOptions = param.donateOptions, countryCode = param.countryCode, canonical = param.canonical;
    var redirectHome = function redirectHome() {
        router.push(_helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.root */ .xm.root(user, locale));
    };
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(enums__WEBPACK_IMPORTED_MODULE_11__/* .Namespace.Theaters */ .lS.Theaters).t;
    var createNotification = (0,context__WEBPACK_IMPORTED_MODULE_15__/* .useNotificationContext */ .nw)().createNotification;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(donateOptions[0].value), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), customAmount = ref2[0], setCustomAmount = ref2[1];
    var formRef = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var ref3 = (0,_context_authContext__WEBPACK_IMPORTED_MODULE_9__/* .useAuth */ .aC)(), user = ref3.user, isAnonymous = ref3.isAnonymous, isUserLoaded = ref3.isUserLoaded;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_17__/* .useLang */ .J)().locale;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), selectedCard = ref4[0], setSelectedCard = ref4[1];
    var getCurrency = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        // fallback to EUR
        if (donateOptions.length === 0) {
            return _typings_api__WEBPACK_IMPORTED_MODULE_3__/* .Currency.Eur */ .F.Eur;
        } else {
            return donateOptions[0].currency;
        }
    }, [
        donateOptions
    ]);
    var getMinMaxCurrency = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var curr = getCurrency();
        if (curr === _typings_api__WEBPACK_IMPORTED_MODULE_3__/* .Currency.Czk */ .F.Czk) {
            return [
                30,
                999999
            ];
        } else if (curr === _typings_api__WEBPACK_IMPORTED_MODULE_3__/* .Currency.Eur */ .F.Eur) {
            return [
                1,
                100000
            ];
        } else if (curr === _typings_api__WEBPACK_IMPORTED_MODULE_3__/* .Currency.Uah */ .F.Uah) {
            return [
                40,
                999999
            ];
        } else if (curr === _typings_api__WEBPACK_IMPORTED_MODULE_3__/* .Currency.Pln */ .F.Pln) {
            return [
                10,
                999999
            ];
        }
        return [
            0,
            0
        ];
    }, [
        getCurrency
    ]);
    var ref5 = (0,_context_stripeContext__WEBPACK_IMPORTED_MODULE_12__/* .useStripeCtx */ .o)(), cardHasError = ref5.cardHasError, createPaymentMethod = ref5.createPaymentMethod, confirmCardPayment = ref5.confirmCardPayment, stripeError = ref5.stripeError, stripeCard = ref5.stripeCard;
    var currency = getCurrency();
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(getMinMaxCurrency(), 2), donateMin = ref6[0], donateMax = ref6[1];
    var RULE_DONATE_MIN = t("min_donate", {
        value: donateMin,
        currency: currency
    });
    var RULE_DONATE_MAX = t("max_donate", {
        value: donateMax,
        currency: currency
    });
    var RULE_NOT_EMPTY = t("common:form.not_empty");
    var RULE_WRONG_EMAIL = t("common:form.email_format");
    var onChange = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(event) {
        setValue(parseInt(event.target.value));
    }, [
        value
    ]);
    var onAmountChange = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(event) {
        setCustomAmount(event.target.value);
    }, [
        value
    ]);
    var onSubmit = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
            var formSchemaObj, validateObject, form, formSchema, valid, amount, ref, currency, price, paymentRes, email, res, paymentResp, payMethod, respPay, res1, paymentResp1;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        formSchemaObj = {};
                        validateObject = {};
                        if (value === -1) {
                            formSchemaObj["custom"] = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .donateRule */ .EZ)(RULE_DONATE_MIN, RULE_DONATE_MAX, donateMin, donateMax);
                            validateObject["custom"] = customAmount;
                        }
                        form = event.target;
                        if (!user) {
                            validateObject["email"] = form.email.value;
                            formSchemaObj["email"] = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .emailRule */ .$D)(RULE_WRONG_EMAIL, RULE_NOT_EMPTY);
                        }
                        formSchema = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .createFormSchema */ .ZS)(formSchemaObj);
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .setLoadingState */ .bG)(formRef.current);
                        valid = true;
                        if (value === -1 || !user) {
                            valid = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .validateForm */ .G$)(formSchema, validateObject, formRef.current);
                        }
                        amount = value === -1 ? customAmount : value.toString();
                        ref = donateOptions[0], currency = ref.currency, price = ref.value;
                        if (cardHasError && stripeCard.current && stripeError.current) {
                            stripeCard.current.classList.add("error");
                            stripeError.current.innerHTML = t("choose-plan:card_number_invalid");
                        }
                        if (!(valid && isAnonymous && !cardHasError)) {
                            _ctx.next = 40;
                            break;
                        }
                        _ctx.next = 17;
                        return createPaymentMethod();
                    case 17:
                        paymentRes = _ctx.sent;
                        if (!paymentRes.error) {
                            _ctx.next = 22;
                            break;
                        }
                        {
                            createNotification({
                                title: t("donation_fail")
                            });
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(formRef.current);
                        }
                        _ctx.next = 38;
                        break;
                    case 22:
                        email = form.email.value;
                        _ctx.next = 25;
                        return (0,_api_client__WEBPACK_IMPORTED_MODULE_2__/* .getSharedApiClient */ .L)().paymentDonation({
                            payment_method: paymentRes.paymentMethod.id,
                            currency: currency,
                            amount: amount,
                            theatre_id: theatre.id,
                            email: email
                        });
                    case 25:
                        res = _ctx.sent;
                        if (!(res.status === "SUCCEEDED")) {
                            _ctx.next = 30;
                            break;
                        }
                        {
                            createNotification({
                                title: t("donation_success")
                            });
                            redirectHome();
                        }
                        _ctx.next = 38;
                        break;
                    case 30:
                        if (!(res.status === "ACTION_REQUIRED")) {
                            _ctx.next = 37;
                            break;
                        }
                        _ctx.next = 33;
                        return confirmCardPayment(res.payment_intent_client_secret, null, paymentRes.paymentMethod.id);
                    case 33:
                        paymentResp = _ctx.sent;
                        if (paymentResp.error) {
                            stripeCard.current.classList.add("error");
                            stripeError.current.innerHTML = paymentResp.error.message;
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(formRef.current);
                        } else {
                            helpers_Analytics__WEBPACK_IMPORTED_MODULE_16__/* ["default"].v2_theatreDonation */ .ZP.v2_theatreDonation(theatre.name, currency, price);
                            createNotification({
                                title: t("donation_success")
                            });
                            redirectHome();
                        }
                        _ctx.next = 38;
                        break;
                    case 37:
                        {
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(formRef.current);
                            createNotification({
                                title: t("donation_fail")
                            });
                        }
                    case 38:
                        _ctx.next = 73;
                        break;
                    case 40:
                        if (!(valid && user && !cardHasError)) {
                            _ctx.next = 72;
                            break;
                        }
                        ;
                        console.log("selected card ", selectedCard);
                        if (!(selectedCard !== enums__WEBPACK_IMPORTED_MODULE_11__/* .CardType.NewCard */ .eT.NewCard && selectedCard !== "")) {
                            _ctx.next = 47;
                            break;
                        }
                        {
                            // user choose saved card, try pay with it
                            console.log("set card ", selectedCard);
                            payMethod = selectedCard;
                        }
                        _ctx.next = 52;
                        break;
                    case 47:
                        if (cardHasError) {
                            _ctx.next = 52;
                            break;
                        }
                        _ctx.next = 50;
                        return createPaymentMethod();
                    case 50:
                        respPay = _ctx.sent;
                        if (respPay.error) {
                            createNotification({
                                title: t("donation_fail")
                            });
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(formRef.current);
                        } else {
                            payMethod = respPay.paymentMethod.id;
                        }
                    case 52:
                        _ctx.prev = 52;
                        _ctx.next = 55;
                        return (0,_api_client__WEBPACK_IMPORTED_MODULE_2__/* .getSharedApiClient */ .L)().paymentDonation({
                            payment_method: payMethod,
                            currency: currency,
                            amount: amount,
                            theatre_id: theatre.id
                        });
                    case 55:
                        res1 = _ctx.sent;
                        if (!(res1.status === "ACTION_REQUIRED")) {
                            _ctx.next = 63;
                            break;
                        }
                        _ctx.next = 59;
                        return confirmCardPayment(res1.payment_intent_client_secret, null, payMethod);
                    case 59:
                        paymentResp1 = _ctx.sent;
                        if (paymentResp1.error) {
                            stripeCard.current.classList.add("error");
                            stripeError.current.innerHTML = paymentResp1.error.message;
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(formRef.current);
                        } else {
                            createNotification({
                                title: t("donation_success")
                            });
                            redirectHome();
                        }
                        _ctx.next = 64;
                        break;
                    case 63:
                        {
                            createNotification({
                                title: t("donation_success")
                            });
                            redirectHome();
                        }
                    case 64:
                        _ctx.next = 70;
                        break;
                    case 66:
                        _ctx.prev = 66;
                        _ctx.t0 = _ctx["catch"](52);
                        createNotification({
                            title: t("donation_fail")
                        });
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(formRef.current);
                    case 70:
                        _ctx.next = 73;
                        break;
                    case 72:
                        {
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(formRef.current);
                        }
                    case 73:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    52,
                    66
                ]
            ]);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        customAmount,
        formRef,
        cardHasError,
        value,
        user,
        selectedCard,
        createPaymentMethod,
        confirmCardPayment,
        stripeError,
        stripeCard, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_13___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_14__/* .basicSEO */ .F)(t("seo:donate_title", {
                    theatre: theatre.name
                }), t("seo:donate_description"), undefined, undefined, true, canonical)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default().donate),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default().donateWrapper),
                    children: !isUserLoaded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_LoadingComponent__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                        spinnerSize: "medium"
                    }) : isUserLoaded && !user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "donate-temp-message",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                children: t("must_login")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                href: _helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.login */ .xm.login(locale),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                    className: "btn btn-primary",
                                    children: t("common:menu.login")
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                children: theatre === null || theatre === void 0 ? void 0 : theatre.name
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                children: t("donate_how_much")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                children: t("donate_note")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                ref: formRef,
                                onSubmit: onSubmit,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: [
                                            "radios",
                                            (_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default().radios)
                                        ].join(" "),
                                        children: [
                                            donateOptions.map(function(option, i) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                            type: "radio",
                                                            name: "amount",
                                                            value: option.value,
                                                            onChange: onChange,
                                                            checked: value === option.value,
                                                            id: "amount".concat(i)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                            className: "radio",
                                                            htmlFor: "amount".concat(i),
                                                            children: option.formatted
                                                        })
                                                    ]
                                                }, i);
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                type: "radio",
                                                name: "amount",
                                                value: "-1",
                                                id: "amount",
                                                onChange: onChange,
                                                className: "custom-amount"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                                className: "radio",
                                                htmlFor: "amount",
                                                children: t("amount_other")
                                            }),
                                            value === -1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                                children: [
                                                    t("amount_in_currency", {
                                                        currency: (ref = donateOptions[0]) === null || ref === void 0 ? void 0 : ref.currency
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                        type: "text",
                                                        id: "custom",
                                                        name: "custom",
                                                        onChange: onAmountChange,
                                                        autoComplete: "off"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Cards__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        setSelected: setSelectedCard,
                                        selected: selectedCard
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                        type: "submit",
                                        className: "btn btn-primary",
                                        children: t("button_submit")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_StripeDisclaimer__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {})
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,_context_authContext__WEBPACK_IMPORTED_MODULE_9__/* .withForcePlanToLoggedInUnsubs */ .DE)((0,_context_stripeContext__WEBPACK_IMPORTED_MODULE_12__/* .ProvideStripe */ .U)(DonateTheater)));


/***/ }),

/***/ 12701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardLabel":"Cards_cardLabel__l0VA0","cardIcon":"Cards_cardIcon__nBYYK"};

/***/ }),

/***/ 56047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"donate":"donate_donate__Vv01Y","donateWrapper":"donate_donateWrapper__3EoWv","radios":"donate_radios__38iLL","donateSelect":"donate_donateSelect__ZAg1g","imagePlaceholder":"donate_imagePlaceholder__iu6hc","withoutLogo":"donate_withoutLogo__cgmAM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4743,5429,9774,2888,179], function() { return __webpack_exec__(69859); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);